var render = function render(){
  var _vm$policy, _vm$policy3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": (_vm$policy = _vm.policy) === null || _vm$policy === void 0 ? void 0 : _vm$policy.policyName
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'policy-corner'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to Policy Corner ")])], 1)], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 mb-5 section-content"
  }, [_c('div', {
    staticClass: "container px-3 px-md-0 px-lg-0 px-lg-0"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-start"
  }, [_c('div', {
    staticClass: "text-policy pt-1 mb-4 mr-3"
  }, [_vm._v(" Visit Website: ")]), _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "200"
    },
    on: {
      "click": function () {
        var _vm$policy2;
        return _vm.openPolicyWebsite((_vm$policy2 = _vm.policy) === null || _vm$policy2 === void 0 ? void 0 : _vm$policy2.policyWebsiteUrl);
      }
    }
  }, [_vm._v(" Go to Policy ")])], 1)]), _vm._m(0), _c('div', {
    staticClass: "w-100 h-auto",
    domProps: {
      "innerHTML": _vm._s((_vm$policy3 = _vm.policy) === null || _vm$policy3 === void 0 ? void 0 : _vm$policy3.policyInfoContent)
    }
  })])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row m-0 mt-3 mb-5"
  }, [_c('div', {
    staticClass: "col-12 p-0 text-policy"
  }, [_vm._v(" Policy Overview ")])]);

}]

export { render, staticRenderFns }